import { makeProvider } from "../../makeProvider"
import { SearchResultLogic } from "./logic-new.js"
import { popupProcessor } from "./popupProcessor"

const {Provider, useStore} = makeProvider(props => SearchResultLogic(props,popupProcessor))

export const ListingSearchProvider = Provider
export const useListingSearch = useStore